/**
 * Regroupe des articles par catégorie pour les listes de sélection (optgroup),
 * comme sur l'entrée en stock de la boutique. `categories` est l'arbre de
 * get/categories/collection (catégories avec leurs `childrens`).
 */
export function flattenCategories(categories = []) {
    const flat = []
    categories.forEach((category) => {
        flat.push(category)
        if (category.childrens && category.childrens.length) {
            flat.push(...category.childrens)
        }
    })
    return flat
}

export function groupProductsByCategory(products = [], categories = []) {
    const flat = flattenCategories(categories)
    const groups = {}
    products.forEach((product) => {
        const categoryId = product.product_category_id || 'none'
        if (!groups[categoryId]) {
            const category = flat.find(c => c.id === categoryId)
            groups[categoryId] = {category_id: categoryId, category_name: category?.name || '—', products: []}
        }
        groups[categoryId].products.push(product)
    })
    return Object.values(groups).sort((a, b) => a.category_name.localeCompare(b.category_name))
}
